<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
	<div class="header" :class="{ 'header-transparent dark': transparent, 'header-light head-shadow': !transparent }">
		<div class="container">
			<nav id="navigation"
				:class="windowWidth > 991 ? 'navigation navigation-landscape' : 'navigation navigation-portrait'">
				<div class="nav-header nav-header-mini">
					<router-link to="" class="nav-brand text-logo">
						<span class="svg-icon text-primary svg-icon-2hx">
							<img :src="logo">
						</span>
					</router-link>

					<a v-if="$route.params.slugAvocat" class="profil-button"
						:href="`https://www.callalawyer.fr/avocats/${$route.params.slugAvocat}`">
						Retour sur le profil de l'avocat
					</a>
					<a v-if="$route.params.slugCabinet" class="profil-button"
						:href="`https://www.callalawyer.fr/cabinets/${$route.params.slugCabinet}`">
						Retour sur le profil du cabinet
					</a>
				</div>
			</nav>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue';

import users from '@/assets/img/svg/users.svg'
import add from '@/assets/img/svg/add.svg'
import bar from '@/assets/img/svg/bar.svg'
import logo from '@/assets/img/logo-rdv-legal.svg'

import { useRoute } from 'vue-router';
import { navProperty, navProperty2 } from '@/data/data';

defineProps({
	transparent: Boolean
})

const activeMenu = ref({});
const router = useRoute();
const toggle = ref(false)
const current = ref(router.path);
const windowWidth = ref(window.innerWidth);

const scroll = ref(false)

const handleResize = () => {
	windowWidth.value = window.innerWidth;
};

const handleScroll = () => {
	if (window.scrollY >= 50) {
		scroll.value = true
	} else {
		scroll.value = false
	}
}


onMounted(() => {
	window.scrollTo(0, 0)
	window.addEventListener('resize', handleResize);
	window.addEventListener('scroll', handleScroll);
})

const handleMouseEnter = (menu, submenu = 'main') => {
	if (!activeMenu.value[menu]) {
		activeMenu.value[menu] = {};
	}
	activeMenu.value[menu][submenu] = true;
};

const handleMouseLeave = (menu, submenu = 'main') => {
	if (activeMenu.value[menu]) {
		activeMenu.value[menu][submenu] = false;
	}
};

</script>

<style lang="scss" scoped>
.header {
	display: flex;
	align-items: center;
	height: 64px;
	position: sticky;
	top: 0px;
	padding-block: .5rem;
	background: #fff;
	border-bottom: 1px dashed #d5dee6;
	z-index: 999;
	box-shadow: 0 0 20px #0000000d;
}

.nav-header-mini {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

}

.profil-button {
	text-align: center;
	border-radius: 8px;
	margin-top: .5rem;
	margin-bottom: .5rem;
	padding-left: .5rem;
	padding-right: .5rem;
	padding-top: .5rem;
	padding-bottom: .5rem;
	font-size: 14px;
	color: #637381;
	transition: all .2s;

	&:is(:hover, :focus) {
		background-color: rgba(var(--light-silver), 1);
	}
}
</style>
